import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiEndPoint } from "../../app.component";
import { PaginationData } from "../models/box";
import {
  Sale,
  SaleItemInput,
  SaleReport,
  WebOrder,
  WebOrderItem,
} from "../models/sales";

@Injectable({
  providedIn: "root",
})
export class SalesService {
  base: string = ApiEndPoint + "sales/";

  constructor(private http: HttpClient) {}
  listOffers() {
    return this.http.get(`${this.base}offer/list/`);
  }
  listDeliveryCompany() {
    return this.http.get(`${this.base}deliveryCompany/list/`);
  }
  myOffer() {
    return this.http.get(`${this.base}offer/myOffer/`);
  }
  createOffer(data) {
    return this.http.post(`${this.base}offer/create/`, data);
  }
  updateOffer(data) {
    return this.http.put(`${this.base}offer/edit/${data.id}/`, data);
  }

  listProfitReportByPeriod(from: string, to: string) {
    return this.http.get(`${ApiEndPoint}store/generalReport/${from}/${to}/`);
  }

  deleteOffer(id: number) {
    return this.http.delete(`${this.base}offer/edit/${id}/`);
  }
  makeSale(data) {
    return this.http.post(`${this.base}doSale/`, data);
  }
  FatoraFromBarcode(barcode: string) {
    return this.http.get(`${this.base}soldFatora/${barcode}/`);
  }
  FatoraFromItemBarcode(barcode: string) {
    return this.http.get(`${this.base}soldFatoraFromItem/${barcode}/`);
  }
  returnFatoraItem(fatoraItemId: number) {
    return this.http.get(`${this.base}itemReturn/${fatoraItemId}/`);
  }
  updateFatora(data: SaleItemInput): Observable<SaleItemInput> {
    return this.http.put<SaleItemInput>(
      `${this.base}fatoraitem/edit/${data.id}/`,
      data
    );
  }

  listTodaySales() {
    return this.http.get(`${this.base}today`);
  }

  isBlackList(phoneNumber) {
    return this.http.get(
      `${this.base}webOrder/isBlackList/` + phoneNumber + "/"
    );
  }

  listSalesByPeriod(from: string, to: string) {
    return this.http.get(`${this.base}period/${from}/${to}/`);
  }

  listSalesByPeriodWithType(from: string, to: string, saleType: number) {
    return this.http.get(`${this.base}periodType/${from}/${to}/${saleType}/`);
  }
  createWebOrder(data: WebOrder): Observable<WebOrder> {
    return this.http.post<WebOrder>(`${this.base}webOrder/create/`, data);
  }
  updateWebOrder(data: WebOrder): Observable<WebOrder> {
    return this.http.put<WebOrder>(
      `${this.base}webOrder/edit/${data.id}/`,
      data
    );
  }
  deleteWebOrder({ id }: Pick<WebOrder, "id">) {
    return this.http.delete<WebOrder>(`${this.base}webOrder/edit/${id}`);
  }
  createWebOrderItem(data: WebOrderItem): Observable<WebOrderItem> {
    return this.http.post<WebOrderItem>(
      `${this.base}webOrderItems/create/`,
      data
    );
  }
  updateWebOrderItem(data: WebOrderItem): Observable<WebOrderItem> {
    return this.http.put<WebOrderItem>(
      `${this.base}webOrderItems/edit/${data.id}/`,
      data
    );
  }
  listMyOrders(): Observable<WebOrder[]> {
    return this.http.get<WebOrder[]>(`${this.base}webOrder/myOrders/`);
  }
  listOrders(): Observable<WebOrder[]> {
    return this.http.get<WebOrder[]>(`${this.base}webOrder/list/`);
  }

  listSuppliedOrders(): Observable<SaleReport[]> {
    return this.http.get<SaleReport[]>(`${this.base}webOrder/supplied/`);
  }

  listSuppliedOrdersPagination(
    number: number,
    txtSearch: string
  ): Observable<PaginationData<SaleReport>> {
    return this.http.post<PaginationData<SaleReport>>(
      `${this.base}webOrder/supplied/?page=${number + 1}`,
      {
        txtSearch: txtSearch,
      }
    );
  }

  supplyOrder(
    order: WebOrder
  ): Observable<{ message: string; result: boolean }> {
    return this.http.get<{ message: string; result: boolean }>(
      `${this.base}webOrder/supply/${order.id}/${order.deliveryCompany}/`
    );
  }

  deliverOrder(order: WebOrder): Observable<{ result: boolean }> {
    return this.http.get<{ result: boolean }>(
      `${this.base}webOrder/deliver/${order.id}`
    );
  }
  blackList(order: WebOrder): Observable<{ result: boolean }> {
    return this.http.get<{ result: boolean }>(
      `${this.base}webOrder/blackList/${order.id}`
    );
  }

  listOrdersPagination(
    number: number,
    searhKey
  ): Observable<PaginationData<SaleReport>> {
    return this.http.get<PaginationData<SaleReport>>(
      `${this.base}webOrder/delivered/${searhKey}/?page=${number + 1}`
    );
  }

  listOnDeptItemsPagination(
    dtfrom,
    dtto,
    dlvc,
    number: number
  ): Observable<SaleReport[]> {
    return this.http.get<SaleReport[]>(
      `${this.base}webOrder/onDebt/${dtfrom}/${dtto}/${dlvc}/?page=${
        number + 1
      }`
    );
  }

  listOnDeptItems(dtfrom, dtto, dlvc): Observable<SaleReport[]> {
    return this.http.get<SaleReport[]>(
      `${this.base}webOrder/onDebt/${dtfrom}/${dtto}/${dlvc}/`
    );
  }

  paidToAdmin(order: WebOrder): Observable<{ result: boolean }> {
    return this.http.get<{ result: boolean }>(
      `${this.base}webOrder/paidToAdmin/${order.id}`
    );
  }
}
